<template>
  <div>
    <div style="padding: 20px">
      <v-col>
        <h2>Test a Pipeline</h2>
        <v-textarea
          rows="4"
          v-model="pipe"
          outlined
          label="Insert Pipeline Code"
        >
        </v-textarea>
        <div v-if="vars.length > 0">Variable values</div>
        <v-layout row wrap>
          <v-flex v-for="item in vars" :key="item" xs12 sm6 md4 lg3 xl2>
            <v-text-field
              style="padding: 10px"
              outlined
              :label="item"
              v-model="vals[item]"
            >
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-select label="table" v-model="table" :items="tables"> </v-select>
          <v-spacer />
          <v-select v-model="loc" label="location" :items="['auth', 'org']">
          </v-select>
          <v-spacer />
          <v-btn
            :disabled="
              loc == null ||
              loc == '' ||
              pipe == null ||
              pipe == '' ||
              table == null ||
              table == ''
            "
            style="background-color: green; margin-top: 15px"
            @click="run"
            >run</v-btn
          >
        </v-layout>
        <v-textarea rows="4" v-model="result" outlined label="Result">
        </v-textarea>
        <div v-if="numItems != 0">{{ numItems }} items</div>
      </v-col>
    </div>
    <h3>Saved Pipelines</h3>
    <server-table-component
      server="login"
      table="pipelines"
      :refresh="true"
      schema="sch_pipelines"
      :enableRowClick="clickEnable"
      @clickedRows="clickedRows"
    >
    </server-table-component>
  </div>
</template>
<script>
import axiosInstances from "@/../../coreui/server/axiosInstances"
import pipeUtils from "@/../../cortex/src/library/pipes"
export default {
  data: () => ({
    loc: "org",
    pipe: null,
    table: null,
    tables: ["a", "b"],
    vars: [],
    vals: {},
    result: null,
    server: null,
    clickEnable: true,
    numItems: 0,
    selectedRows: [],
    results: [],
  }),
  watch: {
    vals: {
      deep: true,
      handler(value) {
        // console.log(this.pipe,(Object.values(value)).length , (Object.keys(value)).length, Object.keys(value))
        if (this.pipe == null || this.vars.length != (Object.values(value)).length) {
          return
        }
        // let res = this.format(this.pipe, value)
        console.log( this.vars, Object.values(value))
      },
    },
    loc: {
      immediate: true,
      async handler(val) {
        if (val == "auth") {
          this.server = axiosInstances.loginServer;
        } else {
          this.server = axiosInstances.apiServer;
        }
        let res = await this.server.get("/dt/v1/collections");
        this.tables = res.data.filter(
          (i) =>
            i.substring(0, 3) != "sch" && i.substring(i.length - 6) != "events"
        );
        console.log(this.tables);
      },
    },
  },
  methods: {
    replaceAll (string, vals) {
      console.log(`string = ${string}`)
      console.log(this.vals)
      for (let i=0; i< (Object.keys(vals)).length; i++) {
        string = this.replaceString('%%', Object.keys(vals)[i], vals[Object.keys(vals)[i]], string)
        console.log('***', Object.keys(vals)[i], vals[Object.keys(vals)[i]], string)
      }
      return string
    },
    replaceString : (marker, key, value, originalString) => {
      const replaceString = `${marker}${key}${marker}`
      let re = new RegExp(replaceString, "g")
      let newString = originalString.replace(re, value)
      return newString
    },
    getFromBetween:function (sub1,sub2) {
        if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
        var SP = this.string.indexOf(sub1)+sub1.length;
        var string1 = this.string.substr(0,SP);
        var string2 = this.string.substr(SP);
        var TP = string1.length + string2.indexOf(sub2);
        return this.string.substring(SP,TP);
    },
    removeFromBetween:function (sub1,sub2) {
        if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
        var removal = sub1+this.getFromBetween(sub1,sub2)+sub2;
        this.string = this.string.replace(removal,"");
    },
    getAllResults:function (sub1,sub2) {
        // first check to see if we do have both substrings
        if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return;

        // find one result
        var result = this.getFromBetween(sub1,sub2);
        // push it to the results array
        this.results.push(result);
        // remove the most recently found one from the string
        this.removeFromBetween(sub1,sub2);

        // if there's more substrings
        if(this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
            this.getAllResults(sub1,sub2);
        }
        else return;
    },
    get:function (string,sub1,sub2) {
        this.results = [];
        this.string = string;
        this.getAllResults(sub1,sub2);
        return this.results;
    },
    async run() {
      this.string = JSON.stringify(this.pipe)
      this.string = pipeUtils.replaceAll(this.string, this.vals)
      // this.string = this.replaceAll(this.string, this.vals)

      
      // return
      let p = JSON.parse(this.string);
      console.log(p)
      this.result = null;
      let res = await this.server.post(
        "/misc/dbops?c=" + this.table + "&op=pipe",
        p
      );
      console.log(res.data);
      if (res.data == null || res.data.length == 0) {
        this.result = "Operation did not return any result";
        this.numItems = 0
      } else {
        this.numItems = res.data.length;
        this.result = JSON.stringify(res.data, undefined, 4);
      }
    },
    async clickedRows(rows) {
      this.selectedRows = rows;
      console.log(this.selectedRows[0]);
      let res = await axiosInstances.loginServer.get(
        "/dt/v1/pipelines/" + this.selectedRows[0]
      );
      if (res.data != null) {
        this.string = res.data["pipe"]
        console.log(this.string)
        this.pipe = JSON.stringify(JSON.parse(res.data["pipe"]), null, 2);
      }
      this.vars = []
      this.vals = {}
      this.results = []
      
      // this.getAllResults('%%', '%%')
      // this.vars = [...new Set(this.results)]
console.log(pipeUtils.getFromBetween.get(this.string, '%%', '%%'))
      this.vars = pipeUtils.getUniqueFromBetween(this.string, '%%', '%%') //[...new Set(pipeUtils.getFromBetween.get(this.string, '%%', '%%'))]
      // let vars = this.extract_vars(this.pipe)
      // let vars_defaults = this.parse_vars(vars)
      // this.vars = []
      // vars_defaults.forEach( (item) => {
      //   this.vars.push(item['name'])
      // })
      this.resetRowSelection();
    },
    resetRowSelection() {
      this.clickEnable = false;
      this.selectedRows = [];
      this.$nextTick(() => {
        this.clickEnable = true;
      });
    },
    extract_vars(template, openChar, closeChar) {
      openChar = openChar || "${";
      closeChar = closeChar || "}";

      var i = 0
      var data = []

      do {
        if (template[i] == "{") {
          for (var j = i + 1; j < template.length; j++) {
            if (template[j] == "}") {
              data[data.length] = template.slice(i + 1, j)
              i = j + 1
              break
            }
          }
        }
      } while (++i < template.length)
      return data;
    },

    parse_vars(vars, delimiter) {
      delimiter = delimiter || ":"
      return vars.map(function (item) {
        var a = item.split(delimiter)
        return { name: a[0], default: a[1] }
      })
    },

    format : (template, params) => {
    let tpl = template.replace(/\${(?!this\.)/g, "${this.");
    let tpl_func = new Function(`return \`${tpl}\``);

    return tpl_func.call(params);
}
  },

  async mounted() {
    // let res = this.format("this is a ${test} of literals ${none}", {test: 'hello', none: 'dev'})
    // console.log(res)
//     this.string = 'this is the haystack {{{0}}} {{{1}}} {{{2}}} {{{3}}} {{{4}}} some text {{{5}}} end of haystack';
// this.getAllResults("{{{","}}}");
// console.log(this.results);
// console.log(this.extract_vars(this.string, "{{{", "}}}"))
    // var aa = this.extract_vars(
    //   "The {adj} {color:brown} fox jumps over the lazy {animal:dog}."
    // );
    // console.log(aa);

    // var vars = this.parse_vars(aa);

    // console.log(vars);

    // console.log(vars[0].default ? "has default" : "no default");
  },
};
</script>
<style >
/* textarea {
  overflow-y: scroll;
  height: 100px;
  resize: none; 
} */
</style>